/**
 * Con cambios sin guardar, avisa antes de salir de la pantalla. Es lo mismo que hacen el editor de plantillas
 * (`wa-oficial/components/editor-plantilla/EditorPlantilla.tsx`) y el de públicos (`PublicoEditorPage.tsx`):
 *
 * - Cerrar o recargar la pestaña: `beforeunload` (el navegador muestra su propio cartel).
 * - Un link de la SPA (el menú, «Atrás», los pasos) no dispara `beforeunload`, y sin `useBlocker` (BrowserRouter, no
 *   data router) no hay cómo frenar la navegación: se pregunta antes de que el `Link` navegue, en captura sobre
 *   `document` (corre antes que React; sin la propagación, el `Link` ni se entera). Lo que abre otra pestaña o sale del
 *   sitio no pierde nada.
 */
import { useEffect } from "react";

export function useAvisoSinGuardar(sucio: boolean, pregunta: string): void {
  useEffect(() => {
    if (!sucio) return;
    const alCerrar = (e: BeforeUnloadEvent) => { e.preventDefault(); e.returnValue = ""; };
    const alTocarUnLink = (e: MouseEvent) => {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const a = e.target instanceof Element ? e.target.closest<HTMLAnchorElement>("a[href]") : null;
      if (!a || a.target === "_blank" || a.origin !== window.location.origin) return;
      if (window.confirm(pregunta)) return;
      e.preventDefault();
      e.stopPropagation();
    };
    window.addEventListener("beforeunload", alCerrar);
    document.addEventListener("click", alTocarUnLink, true);
    return () => {
      window.removeEventListener("beforeunload", alCerrar);
      document.removeEventListener("click", alTocarUnLink, true);
    };
  }, [sucio, pregunta]);
}
